export function toString(state: KeyboardState): string {
  return state.join('') || '0';
}
